import { render } from "./TableInput.vue?vue&type=template&id=64e6c7db"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__